import React, { memo, PropsWithChildren } from 'react';
import { IGapProps, IGutterProps, useCommonGapsCss, useGutterCss } from './space';
import styled from 'styled-components';
import { BaseDiv } from '../../common/BaseElements';

export interface ISpaceContainerProps extends PropsWithChildren, IGutterProps {}

const GutterContainer = styled(BaseDiv)<IGutterProps>`
  ${useGutterCss()}
`;

// NOTE: Only use this as container and apply styles to it
// Be mindful not to overly use this for spacing purposes only
// Remember: AVOID <div> soup
export const SpaceContainerInternal = React.forwardRef<HTMLDivElement, ISpaceContainerProps>(({ children, ...rest }, ref) => (
  <GutterContainer ref={ref} {...rest}>
    {children}
  </GutterContainer>
));

export const SpaceContainer = memo(SpaceContainerInternal);

const CommonGapContainer = styled(BaseDiv)<IGapProps & IGutterProps>`
  ${useCommonGapsCss()}
  ${useGutterCss()}
`;

// NOTE: Only use this as container and apply styles to it
// Be mindful not to overly use this for spacing purposes only
// Remember: AVOID <div> soup
const GapContainerInternal = styled(
  React.forwardRef<HTMLDivElement, React.PropsWithChildren<IGapProps & IGutterProps>>(({ children, ...rest }, ref) => (
    <CommonGapContainer ref={ref} {...rest}>
      {children}
    </CommonGapContainer>
  ))
)``;

export const GapContainer = memo(GapContainerInternal);
